import type { Raster } from '@repo/warp-engine';
import { drawRasterToCanvas } from '@/shared/lib';

/** 견적 요청 화면에 작게 보여 줄 앞면 미리보기의 긴 변 상한(px) — localStorage 에 두므로 작게 줄인다. */
export const PREVIEW_MAX_SIDE_PX = 640;

const ENCODE_QUALITY = 0.85;

/**
 * 면 미리보기 래스터를 긴 변 640px 이하의 webp data URL 로 만든다. 키우지는 않는다.
 * 투명한 곳은 흰색으로 깐다(jpeg 에서 검게 나오지 않게). webp 인코딩을 못 하는 브라우저(png 로 되돌려 줌)는 jpeg 로 만든다.
 * 캔버스를 못 쓰거나 인코딩이 안 되면 던지지 않고 null — 미리보기는 있으면 좋은 부가 정보다.
 */
export const encodePreviewImage = (raster: Raster): string | null => {
  try {
    const source = document.createElement('canvas');
    drawRasterToCanvas(source, raster);
    const ratio = Math.min(1, PREVIEW_MAX_SIDE_PX / Math.max(raster.width, raster.height));
    const target = document.createElement('canvas');
    target.width = Math.max(1, Math.round(raster.width * ratio));
    target.height = Math.max(1, Math.round(raster.height * ratio));
    const context = target.getContext('2d');
    if (context === null) return null;
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, target.width, target.height);
    context.imageSmoothingQuality = 'high';
    context.drawImage(source, 0, 0, target.width, target.height);
    const webp = target.toDataURL('image/webp', ENCODE_QUALITY);
    if (webp.startsWith('data:image/webp')) return webp;
    const jpeg = target.toDataURL('image/jpeg', ENCODE_QUALITY);
    return jpeg.startsWith('data:image/jpeg') ? jpeg : null;
  } catch {
    return null;
  }
};
